import { takeLatest, put, all, call } from 'redux-saga/effects';
import { getAllContent, onSuccess, onFailure } from './bbcUrdu.slice';
import { getAllBBCUrduContentApi } from './bbcUrdu.utils';
export function* fetchAllBBCUrduContent({ payload }) {
  try {
    const { data } = yield call(getAllBBCUrduContentApi, payload);

    yield put(onSuccess(data));
  } catch (error) {
    yield put(onFailure(error.toString()));
  }
}

export function* onFetchBBCUrduContent() {
  yield takeLatest(getAllContent.toString(), fetchAllBBCUrduContent);
}

export function* bbcUrduContentSagas() {
  yield all([call(onFetchBBCUrduContent)]);
}
